import { useLocation } from 'react-router-dom';
import countries from '../../../lib/countries';
import { CaptionText, H5, P3 } from '../../../styles/FontStyles';
import { useWindowWide } from '../../../helpers/wideScreen';
import { AnimatePresence, motion } from 'framer-motion';
import moment from 'moment';
import Marquee from 'react-fast-marquee';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useAppSelector } from '../../../app/hooks';
import { DASHBOARD } from '../../../routes/routes';
import { Flexed } from '../../../styles/GlobalComponents';

const NewMembers = styled(motion.div)`
  z-index: 99;
  height: 60px;
  background: #f2f6ff;
  position: fixed;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 30px;
  top: 70px;
  left: 0;
  right: 0;
`;

const Members = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  overflow-y: hidden;

  img {
    width: 28px;
    height: 20px;
    margin-right: 8px;
  }
`;

export const MarqueeNewMembers = () => {
  const location = useLocation().pathname;
  const wide = useWindowWide(800);
  const { lastRegisteredUsers } = useAppSelector((state) => state.dashboard);
  const { t } = useTranslation('layout');

  return (
    <AnimatePresence exitBeforeEnter>
      {location === DASHBOARD && lastRegisteredUsers?.length && (
        <NewMembers
          key='NewMembers'
          initial={{ transform: 'translateY(-60px)' }}
          animate={{ transform: 'translateY(0px)' }}
          exit={{ transform: 'translateY(-60px)' }}
          transition={{
            duration: 0.2
          }}>
          <div style={{ width: 150 }}>
            {wide ? (
              <H5 bold> {t('new_members')}:</H5>
            ) : (
              <CaptionText bold> {t('new_members')}:</CaptionText>
            )}
          </div>

          <Members>
            {lastRegisteredUsers?.length > 0 && (
              <Marquee
                loop={0}
                gradientColor={[242, 246, 255]}
                speed={40}
                gradientWidth={wide ? 200 : 50}>
                {lastRegisteredUsers?.map((user: any, i: number) => {
                  return (
                    <Flexed center m='0 20px' key={i}>
                      {countries.map((country, i) => {
                        if (country.code === user.countryCode) {
                          return <img key={i} src={country.flag} alt='flag' />;
                        } else if (country.dial_code === user.countryCode) {
                          return <img key={i} src={country.flag} alt='flag' />;
                        } else return null;
                      })}
                      <div>
                        {wide ? (
                          <P3 bold>{user.username}</P3>
                        ) : (
                          <CaptionText bold>{user.username}</CaptionText>
                        )}

                        <CaptionText>
                          {moment(user.dateCreated).fromNow()}
                        </CaptionText>
                      </div>
                    </Flexed>
                  );
                })}
              </Marquee>
            )}
          </Members>
        </NewMembers>
      )}
    </AnimatePresence>
  );
};
